export default {
  title: 'Betaalgateways',
  fields: {
    name: 'Naam',
    payment_gateway: 'Betaalgateways',
    live_from: 'Actief sinds',
    last_30_days_sales: 'Omzet laatste 30 dagen',
    kyc_deadlines: 'KYC-deadlines',
    actions: 'Acties',
  },
  stats: {
    active_on_stripe: 'Actief op Stripe',
    active_on_adyen: 'Actief op Adyen',
    adyen_verification_pending: 'Adyen-verificatie in behandeling',
  },
  filters: {
    search_placeholder: 'Zoeken op naam...',
    gateway_status_placeholder: 'Alle gateways',
  },
  not_configured: {
    title: 'Betalingen zijn nog niet geconfigureerd',
    description:
      'Er is geen betaalprovider verbonden met uw account. Restaurants kunnen volledig worden ingesteld, maar ze kunnen niet live gaan of online betalingen accepteren totdat betalingen zijn geconfigureerd.',
  },
  gateway_statuses: {
    stripe_as_primary: 'Stripe',
    adyen_as_primary: 'Adyen',
    adyen_pending: 'Adyen (in behandeling)',
  },
  gateways: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
  verification_statuses: {
    verified: 'Geverifieerd',
    pending: 'In behandeling',
    rejected: 'Afgewezen',
  },
  buttons: {
    actions: 'Acties',
    switch_to: 'Overschakelen naar {{gateway}}',
    view_details: 'Details bekijken',
    open_onboarding: 'Onboarding openen',
    create_onboarding_link: 'Onboarding-link aanmaken',
  },
  modal: {
    title: 'Betaalgateway wijzigen',
    description:
      'Weet u zeker dat u {{companyName}} wilt overschakelen van <bold>{{currentGateway}}</bold> naar <bold>{{targetGateway}}</bold>?',
    not_verified_warning:
      '{{gateway}} is niet geverifieerd voor dit bedrijf. Betalingsverwerking kan worden beïnvloed.',
    confirm: 'Overschakelen',
    cancel: 'Annuleren',
  },
  details_modal: {
    title: '{{companyName}} — Betaalgateway-details',
    requirements: 'Vereisten',
    no_requirements: 'Geen openstaande vereisten.',
    deadline: 'Deadline',
    capabilities: 'Mogelijkheden',
    onboarding_links: {
      section_title: 'Onboarding-link',
      active_link: 'Actieve link',
      expires: 'Verloopt {{date}}',
      create_button: 'Link aanmaken',
      extend_button: 'Link verlengen',
      loading: 'Links laden…',
    },
  },
  toasts: {
    onboarding_link_failed: 'Aanmaken van onboarding-link mislukt.',
    switch_success: 'Betaalgateway succesvol gewijzigd.',
    switch_failed: 'Wijzigen van betaalgateway mislukt.',
    failed_to_load_data: 'Laden van gegevens mislukt.',
  },
};
